import { useState } from "react"
import { Box, Button, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Repeat } from "lib/@components/repeat"
import { MultiSelectionChipPreviewItem } from "routes/schedule/my-schedules/my-custom-schedules/multi-selection-chip-preview-item"
import Iconify from "minimals-template/components/Iconify"
import { useTheme } from "@mui/material/styles"

export function MultiSelectionChipPreviews({ schedules = [], onRemove }) {
    const theme = useTheme()
    const [isExpanded, setIsExpanded] = useState(false)
    const count = schedules.length
    const hasSchedules = count > 0
    const toggleCaption = isExpanded ? "Hide" : "Show"
    const toggleIcon = isExpanded ? "mdi:chevron-down" : "mdi:chevron-up"
    const scheduleCaption = count === 1 ? "1 selected schedule" : `${count} selected schedules`
    const selectedSchedulesDropdown = "selected-schedules-dropdown"

    return (
        <Box sx={{ mt: 1, pt: 1, borderTop: 1, borderColor: "divider" }} data-cy="multi-selection-chip-previews">
            <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
                <Typography variant="caption" color="text.secondary" data-cy="multi-selection-chip-caption">
                    {scheduleCaption}
                </Typography>
                <If truthy={hasSchedules}>
                    <Button
                        size="small"
                        onClick={toggleExpanded}
                        sx={{
                            fontSize: theme.typography.caption.fontSize,
                            lineHeight: theme.typography.caption.lineHeight,
                            fontWeight: theme.typography.caption.fontWeight,
                        }}
                        aria-controls={selectedSchedulesDropdown}
                        aria-expanded={isExpanded}
                        aria-label={isExpanded ? "Hide selected schedules list" : "Show selected schedules list"}
                        endIcon={<Iconify icon={toggleIcon} width={14} />}
                        data-cy="multi-selection-chip-toggle"
                    >
                        {toggleCaption}
                    </Button>
                </If>
            </Box>
            <If truthy={hasSchedules && isExpanded}>
                <Stack
                    id={selectedSchedulesDropdown}
                    role="region"
                    aria-label="Selected schedules"
                    data-cy="multi-selection-chip-list"
                    mt={1}
                    direction="row"
                    flexWrap="wrap"
                    gap={0.75}
                    sx={{
                        maxHeight: "70px",
                        overflowY: "auto",
                        alignContent: "flex-start",
                        pr: 0.25,
                    }}
                >
                    <Repeat list={schedules} item={<MultiSelectionChipPreviewItem onRemove={onRemove} />} />
                </Stack>
            </If>
        </Box>
    )

    function toggleExpanded() {
        setIsExpanded((previous) => !previous)
    }
}
